import { Box, Collapse } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Extra from './Extra.js'
import { useSelector, useDispatch } from 'react-redux'
import constants from '../../../../js/lib/constants.js'
import { setSelectedExtras } from '../../../../js/lib/redux/slices/booking.js'
import * as lib from '../../../../js/lib/lib.js'

const ExtrasList = ({
  onAddExtra,
  onRemoveExtra,
  dictionary,
  isLoading,
  parentCollapseOpen = true,
}) => {
  // const {
  //   selectedExtras,
  //   selectedVehicle,
  //   isPrepaid: isPrepaidStore,
  // } = useSelector((state) =>
  //   window.bookingData ? state.booking : state.modify
  // )

  const {
    selectedExtras,
    selectedVehicle,
    isPrepaid: isPrepaidStore,
  } = useSelector((state) => state.booking)

  const { prepaidPrice, returnPrice } = selectedVehicle.car
  const dispatch = useDispatch()

  const amenitiesDefinitions = () => {
    if (isPrepaidStore) {
      return prepaidPrice.amenities
    } else {
      return returnPrice.amenities
    }
  }

  const getAmenitiesGroups = () => {
    return [
      ...new Map(
        amenitiesDefinitions().map((amenity) => [
          `${amenity.groupId}_${amenity.groupDescription}`,
          {
            id: amenity.groupId,
            text: amenity.groupDescription,
          },
        ])
      ).values(),
    ]
  }

  const [openStates, setOpenStates] = useState(
    getAmenitiesGroups().reduce(
      (prev, item) => ({ ...prev, [item.id]: true }),
      {}
    )
  )

  const handleAddExtra = (code, quantity) => {
    onAddExtra(code, quantity)
  }
  const handleRemoveExtra = (code) => {
    onRemoveExtra(code)
  }

  const toggleContent = (id) => {
    setOpenStates((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }))
  }

  useEffect(() => {
    const selectedVehiclePrices = isPrepaidStore ? prepaidPrice : returnPrice

    if (selectedVehicle) {
      const preSelectedAmenities = selectedVehiclePrices.amenities
        .filter((item) => item.requestedQuantity > 0)
        .map((item) => ({
          code: item.code,
          quantity: item.requestedQuantity,
          added: constants.extras.manually,
        }))

      const combinedExtras = [...selectedExtras, ...preSelectedAmenities]
      const uniqueExtras = combinedExtras.filter(
        (extra, index, self) =>
          index === self.findIndex((e) => e.code === extra.code)
      )
      dispatch(setSelectedExtras(uniqueExtras))
    }
  }, [])

  // Close all child collapses when parent collapse closes (only on mobile devices)
  useEffect(() => {
    if (!parentCollapseOpen && lib.scrDevices()) {
      setOpenStates(
        getAmenitiesGroups().reduce(
          (prev, item) => ({ ...prev, [item.id]: false }),
          {}
        )
      )
    }
  }, [parentCollapseOpen])

  return (
    <>
      {getAmenitiesGroups() &&
        getAmenitiesGroups().map((group, index) => (
          <div className="s-extras-list__group" key={index}>
            <div
              className={`s-extras-list__group-title ${
                openStates[group.id] ? 'show' : ''
              }`}
              onClick={() => toggleContent(group.id)}>
              <div>
                {group.text}{' '}
                <span>
                  (
                  {
                    amenitiesDefinitions().filter(
                      (amenity) => group.id === amenity.groupId
                    ).length
                  }
                  )
                </span>
              </div>
              <i className="icon-arrow-down arrow" />
            </div>
            <Collapse in={openStates[group.id]} unmountOnExit>
              <Box className="s-extras-list__group-content">
                {amenitiesDefinitions()
                  .filter((amenity) => group.id === amenity.groupId)
                  .map((amenity, index) => (
                    <Extra
                      key={index}
                      dictionary={dictionary}
                      isLoading={isLoading}
                      amenity={amenity}
                      onAddExtra={handleAddExtra}
                      onRemoveExtra={handleRemoveExtra}></Extra>
                  ))}
              </Box>
            </Collapse>
          </div>
        ))}
    </>
  )
}

export default ExtrasList
